import { useDispatch, useSelector } from "react-redux"
import { AuthComp } from "../../../auth/AuthComp"
import { LOGIN } from "../../../global/urlMapping"
import { EsitiLayout } from "../../common/EsitiLayout"
import { Redirect } from "../../tools/Redirect"
import { screeningResultSelector } from "../../../modules/screening/selectors"
import { useEffect } from "react"
import { getScreeningResultAction } from "../../../modules/screening/actions"

export const EsitiCL = () => {
    const dispatch = useDispatch()
    const screeningResult = useSelector(screeningResultSelector);

    useEffect(() => {
        window.scrollTo(0, 0)
        dispatch(getScreeningResultAction('CL'))
    }, [dispatch])
    return (
        <AuthComp fallback={< Redirect link={LOGIN} />} >
            <EsitiLayout esiti={screeningResult?.value?.screeningResults} />
        </AuthComp>
    )
}